import { Typography } from "@/components/atoms";
import { PointsOfInterest } from "@/redux/apis/clientPoi/types";
import { RouteTimeline } from "./RouteTimeline";
import { SummaryCard } from "./SummaryCard";

interface AddressSummaryCardProps {
  /** Ordered `[pickup, ...stops, destination]` (selectOrderedLocations). */
  locations: PointsOfInterest[];
  onEdit?: () => void;
  /** Purple "active" tint — the step currently being viewed/edited. */
  highlighted?: boolean;
  /** Shown under the pickup, so the sheet's only review surface names the flight it timed the car off. */
  pickupFlightNumber?: string | null;
  className?: string;
}

/** Address card of the priced Booking Summary — vertical dotted timeline of the trip's locations. */
export const AddressSummaryCard = ({ locations, onEdit, highlighted, pickupFlightNumber, className }: AddressSummaryCardProps) => (
  <SummaryCard icon="Location" title="Address" onEdit={onEdit} highlighted={highlighted} empty={locations.length === 0} className={className}>
    {locations.length === 0 ? (
      <Typography variant="small-regular" className="text-neutral-dark-gray">
        No locations selected yet
      </Typography>
    ) : (
      <RouteTimeline locations={locations} pickupFlightNumber={pickupFlightNumber} />
    )}
  </SummaryCard>
);
